<template>
    <div class="menu-left left" id="menu">
        <div class="LayoutNav">
            <div class="main">
                <el-menu
                        mode="horizontal"
                        :router="true"
                        :background-color="'#fff'"
                        :text-color="'#000'"
                        :active-text-color="'#000'"
                        :default-active="activeUrl"

                >
                    <menu-item ref="lis" v-for="(item, index) in menus" :key="index" :obj="item"></menu-item>

                </el-menu>

            </div>
        </div>
    </div>
</template>

<script>
    import * as API from "../api/global.js"
    import MenuItem from "./MenuItem";
    import { mapState } from "vuex"
    import {mapActions} from "vuex"
    //import {getScorderPzList} from "../views/promanagement/components/task/api";
    export default {
        name: 'LeftMenu',
        components:{MenuItem},
        data(){
            return{
                activeUrl:'/Index.vue',
                menus:[],
            }
        },
        computed:{
            ...mapState(["routerList","menuList","activeIndex"]),

        },
        watch:{
            $route(to){
                this.activeUrl = to.path;
                 let hash={
                    fullPath:to.fullPath,
                    hash: to.hash,
                    meta:to.meta,
                    name:to.name,
                    path:to.path,
                     mid:to.meta.mid,
                }
                if(to.fullPath!=='/'){
                    this.$store.commit('ADD_VISITED_VIEW',hash);
                    this.$store.commit('set_active_index',to.name);
                  }
                // console.log(to.meta.mid,'to.i_id')
                if (to.meta.mid !== "") {
                    this.mid = to.meta.mid
                    sessionStorage.setItem('mids', to.meta.mid)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }

            },

                menuList(){
                         this.menus =this.sortMenuList(this.menuList);
                        },

        },
        mounted() {
            // console.log(document.getElementById('menu').clientHeight)
        },
        methods:{

            compar(array,key){
                return array.sort(function (a,b) {
                    const x = a[key];
                    const y = b[key];
                    // return x.localeCompare(y);
                    return ((x<y)?-1:((x>y)?1:0));
                });
            },
            sortMenuList(list){


                let fmenuList = [];
                for (let fmenu of list){
                    let fmenuObj = fmenu;
                    let smenuList = [];
                    if (fmenu.smenuList.length>0){
                        for (let smenu of fmenu.smenuList){
                            let smenuObj = smenu;
                            if (smenu.smenuList&&smenu.smenuList.length>0){
                                smenuObj.smenuList = this.compar(smenu.smenuList,'i_order');
                            }
                            smenuList.push(smenuObj);
                        }
                        fmenuObj.smenuList = this.compar(smenuList,'i_order');
                    }
                    fmenuList.push(fmenuObj);
                }
                // console.log(fmenuList);
                return this.compar(fmenuList,'i_order');
            },
        }
    }
</script>
<style  lang="scss" scoped>
    .menu-left{
        margin-top: 3px;

    }
    .menu-left::-webkit-scrollbar{
        width:5px;
    }
    .menu-left::-webkit-scrollbar-track{
        border-radius: 10px;
        background-color: rgba(0,0,0,0.1);
    }
    .menu-left::-webkit-scrollbar-thumb{
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: rgba(0,0,0,0.1);
    }
    .left{
        height:100%;
        overflow-x: auto;
        border-bottom: 1px solid #f3f3f3;
        /*width: 210px;*/
        /*overflow-y: auto;*/
        /*-ms-overflow-y: auto;*/
    }
    /*.scroll{
        overflow-y: auto;
        -ms-overflow-y: auto;
    }*/
  .LayoutNav{

      height: 100%;
      background-color: #fff;

      .main{

          /deep/{
              .el-menu{
                  /*width: calc(100vh - 100px);*/
                  border-right: none;
                  //overflow-x: auto;
                  width: 100%;
                  overflow: no;
              }
              .el-menu-item.is-active{
                  background-color:#dfdcdc !important;
              }
              .el-menu.el-menu--horizontal{
                  border: none;
              }
              .el-menu--horizontal>div{
                  float: left;
              }
              .el-submenu__icon-arrow {
                  position: static;
                  top: 50%;
                  right: 20px;
                  margin-top: -7px;
                  transition: transform .3s;
                  font-size: 12px;
              }
              .el-menu-item, .el-submenu__title {
                  /*float: left;*/
              }

          }
      }
  }

</style>